import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Toast, Picker, List } from 'antd-mobile';
import { Link } from 'react-router-dom';
import Http from '../../config/axiosUtils';
import TeamCommon from '../../components/team/TeamCommon';

import AvaterImg from '../../assets/images/custom/custom_num@2x.png';

class CustomHome extends Component {
  state = {
    customData: {},
    overviewData: {},
    litData: [],
    type: ['all'],
  }

  componentDidMount() {
    this.fetchListData();
    this.fetchData(this.state.type[0])
  }
  fetchListData = async () => {
    const path = '/spread/web/customer/productList';
    const res = await Http.get(path);
    if (res.code === 0) {
      const data = res.data.map((o) => ({
        label: o.value,
        value: o.code,
      }));
      const all = [{label: '全部', value: 'all'}]
      this.setState({
        litData: all.concat(data),
      });
    } else {
      Toast.fail(res.msg, 2);
    }
  }

  fetchData = async (code) => {
    const path = `/spread/web/customer/index/${code}`;
    const res = await Http.get(path);
    if (res.code === 0) {
      this.setState({
        customData: res.data,
        overviewData: res.data.overviewData
      });
    } else {
      Toast.fail(res.msg, 2);
    }
  }

  onChangeType = (type) => {
    console.log(type);
    
    this.setState({
      type: type
    }, () => {
      this.fetchData(type[0]);
    })
  }
  render () {
    const { overviewData } = this.state;
    return (
      <div>
        <Helmet><title>我的客户</title></Helmet>
        <div className='customHome teamHome'>
          <div className='team-top'>
            <div className='top-main'>
              <div className='top-main-avater'><img src={AvaterImg} alt='' /></div>
              <div className='top-main-info'>
                <div className='team-titleAll'>总客户数(人)</div>
                <div className='team-num'>{overviewData.allCount}</div>
              </div>
            </div>
            <div className='top-detail'>
              <ul>
                <li>
                  <div>当月新增客户</div>
                  <div>{overviewData.monthCount}</div>
                </li>
                <li>
                  <div>今日新增客户</div>
                  <div>{overviewData.todayCount}</div>
                </li>
              </ul>
            </div>
            <Link to='/customList'>
              <div className='team-right'>
                <i className='iconfont icon-kehuliebiao'></i>客户列表
              </div>
            </Link>
          </div>
          <div className='group-content'>
            <div className='content-bg'>
              <div className='content-top'>节点数据</div>
              <div className='list-zwl'>
                <div>
                  {this.state.litData.length > 0 && this.state.litData.find(o => o.value === this.state.type[0]).label}<i className='iconfont icon-arrrow'></i>
                  <div className='common-pick list-type-pick'>
                  <Picker
                    extra='请选择'
                    data={this.state.litData}
                    cols={1}
                    value={this.state.type}
                    onChange={this.onChangeType}>
                    <List.Item arrow="horizontal"> 产品 </List.Item>
                  </Picker>
                </div>
                </div>
                
              </div>
              
            </div>
            
            <div className='content-detail'>
              <TeamCommon teamData={this.state.customData} isGroupHome></TeamCommon>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CustomHome;